<template>
  <div class="toast">
    <img
      class="my-prize-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/52deaf199e38c672102995cd921489d1_wh=522_162.png"
      alt=""
    />
    <img
      class="my-gift-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/d02552bacff6ce971e445ace3b848b5e_wh=1125_372.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="my-prize-scroll">
      <div class="prize-list">
        <div class="prize-item" v-for="(item, index) in data" :key="index">
          <div class="item-top">
            <img class="item-image" :src="item.prize_banner" alt="" />
            <div class="item-right">
              <div class="item-name">{{ item.prize_name }}*{{ item.num }}</div>
              <div class="item-desc">
                <span v-if="item.act_prize_level == 1"
                  >奖品款式/颜色随机发放<br />于活动结束后7个工作日内邮寄</span
                >
                <span v-else
                  >奖品款式/颜色随机发放<br />请前往主责门店，展示本页面领取</span
                >
              </div>
            </div>
          </div>
          <div class="item-bottom" v-if="item.act_prize_level == 1">
            <div class="receive-btn" @click="bindFillAddress(item)">{{
              addressData.id ? '查看收货地址' : '填写收货地址'
            }}</div>
          </div>
        </div>
        <div class="empty" v-if="!data.length">
          <img
            class="empty-image"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
            alt=""
          />
          <div class="empty-text">暂无奖品</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  components: { AppLoading },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    addressData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      myCoachList: null
    }
  },
  computed: {},
  watch: {
    show() {}
  },
  created() {},
  methods: {
    bindFillAddress() {
      this.$emit('address')
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;
  padding: 84px 12px 50px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: linear-gradient(180deg, #f1404a 0px, #ffe7c5 406px);
  .my-prize-image {
    width: 174px;
    height: 54px;
    position: absolute;
    top: 18px;
    left: 17px;
  }
  .my-gift-image {
    z-index: -1;
    width: 375px;
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .my-prize-scroll {
    min-height: 84px;
    max-height: 508px;
    overflow-y: scroll;
    .prize-list {
      overflow: hidden;
      padding: 0px 12px 0px;
      .prize-item {
        padding: 12px;
        background: #ffffff;
        border-radius: 8px;
        margin-bottom: 10px;
        .item-top {
          display: flex;
          align-items: center;

          .item-image {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 10px;
          }
          .item-right {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .item-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-weight: bold;
              font-size: 14px;
              color: #050b27;
              line-height: 20px;
              margin-bottom: 6px;
            }
            .item-desc {
              font-size: 12px;
              color: rgba(5, 11, 39, 0.4);
              line-height: 17px;
            }
          }
        }
        .item-bottom {
          margin-top: 12px;
          .receive-btn {
            height: 28px;
            background: #f31b27;
            border-radius: 14px;
            font-weight: 500;
            font-size: 12px;
            color: #ffffff;
            line-height: 28px;
            text-align: center;
          }
        }
      }
      .prize-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .empty {
    width: 100%;
    height: 272px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-image {
      width: 214px;
      height: 112px;
      object-fit: contain;
      margin-bottom: 25px;
    }
    .empty-text {
      font-weight: bold;
      font-size: 16px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 22px;
    }
  }
  .close {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: #fff;
    }
  }
}
</style>
